import { z } from "zod";

const errorMessages = {
  required: "وارد کردن این فیلد اجباری است",
};

const schema = z.object({
  fa_name: z.string().min(1, errorMessages.required),
  en_name: z.string().min(1, errorMessages.required),
  ar_name: z.string().min(1, errorMessages.required),
  is_active: z.boolean().default(false),
});

export { schema };
